import React, {Component} from 'react';
import Slider from "react-slick";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { TalksService } from '../../services/talks';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './event.css';

import {
  BigHeader,
  PageTitle,
  MiniCard,
  Header,
  Categories,
  Card,
  Menu
} from '../../components';

export default class ViewEvent extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    AOS.init({
      // anchorPlacement: 'top-bottom'
      offset: -50
    });
  }

  componentDidMount() {

  }

  onBack() {
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  onCardClick(path, id) {
    window.location = window.location.origin + window.location.pathname + "#/" + path + "/" + id;
  }

  render() {
    var settings = {
      className: "slider variable-width",
      dots: false,
      infinite: true,
      // centerMode: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      variableWidth: true
    };

    return (<div className="rdp-react-template-view-event">
      <BigHeader
        // cover={Capa1}
        cover={""}
        title="educa.fest"
        subtitle="28 e 29 de Novembro,<br/>Av. das Nações Unidas, 14.171"
        onClick={() => this.onBack()}
      />
      <div className="rdp-react-template-view-event-content">
        <div style={{marginBottom: "40px"}} data-aos="fade-up" data-aos-duration="1000">
          <PageTitle label="Acontecendo Agora"/>
          <>
            {TalksService.getTalks().filter(item => item.status === "happening").map(item => {
              return <MiniCard
                type="palestra"
                date={`${item.horario}`}
                title={`<b>Palestra:</b> ${item.titulo}`}
                localization={item.local}
                thumb={item.capa}
                onClick={() => this.onCardClick("palestra", item.id)}
                fullscreen={true}
              />
            })}
          </>
          {/* <MiniCard
            type="palestra"
            date="Palestrante: Sandro Magaldi"
            title="<b>Palestra:</b> Cultura da Empatia: a base do Customer Experience"
            localization="Auditório 1 - 11h00 às 12h30"
            thumb="https://pocs.digitalpages.com.br/bv-super-app/palestras/cultura-da-empatia-a-base-do-customer-experience.png"
            onClick={() => this.onCardClick("palestra", "1")}
            fullscreen={true}
          /> */}
        </div>

        <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500">
          <PageTitle label="Próximas Palestras"/>
          <Slider {...settings}>
            {TalksService.getTalks().filter(item => item.status === "not_started").map(item => {
              return <MiniCard
                type="palestra"
                date={`${item.horario}`}
                title={`<b>Palestra:</b> ${item.titulo}`}
                localization={item.local}
                thumb={item.capa}
                onClick={() => this.onCardClick("palestra", item.id)}
              />
            })}
            {/* <MiniCard
              type="palestra"
              date="Palestrante: Diego Feldberg"
              title="<b>Palestra:</b> Novo líder"
              localization="Auditório 1 - 14h30 às 16h00"
              thumb="https://pocs.digitalpages.com.br/bv-super-app/palestras/novo-lider.png"
              onClick={() => this.onCardClick("palestra", "2")}
            />
            <MiniCard
              type="palestra"
              date="Palestrante: Sandro Magaldi"
              title="<b>Palestra:</b> Gerando valor juntos: dos dados à IA e à inteligência coletiva"
              localization="Auditório 1 - 16h30 às 18h00"
              thumb="https://pocs.digitalpages.com.br/bv-super-app/palestras/gerando-valor-juntos-dos-dados-a-ia-e-a-inteligencia-coletiva.png"
              onClick={() => this.onCardClick("palestra", "3")}
            />
            <MiniCard
              type="palestra"
              date="Palestrante: Sandro Magaldi"
              title="<b>Palestra:</b> Você conhece nossos concorrentes?"
              localization="Auditório 2 - 09h30 às 10h30"
              thumb="https://pocs.digitalpages.com.br/bv-super-app/palestras/voce-conhece-nossos-concorrentes.png"
              onClick={() => this.onCardClick("palestra", "4")}
            /> */}
          </Slider>
        </div>

        <div data-aos="fade-up" data-aos-duration="1000">
          <PageTitle label="Palestras Anteriores"/>
          <Slider {...settings}>
            {TalksService.getTalks().filter(item => item.status === "finished").map(item => {
              return <MiniCard
                type="palestra"
                date={`${item.horario}`}
                title={`<b>Palestra:</b> ${item.titulo}`}
                localization={item.local}
                thumb={item.capa}
                onClick={() => this.onCardClick("palestra", item.id)}
                disabled={item.disabled}
              />
            })}
            {/* <MiniCard
              type="palestra"
              date="Palestrante: Diego Feldberg"
              title="<b>Palestra:</b> Por que mudamos tanto?"
              localization="Auditório 3 - 16h30 às 18h00"
              thumb="https://pocs.digitalpages.com.br/bv-super-app/palestras/por-que-mudamos-tanto.png"
              onClick={() => this.onCardClick("palestra", "5")}
            />
            <MiniCard
              inactive={true}
              type="palestra"
              date="Palestrante: Diego Feldberg"
              title="<b>Palestra:</b> Por que mudamos tanto?"
              localization="Auditório 3 - 16h30 às 18h00"
              thumb="https://pocs.digitalpages.com.br/bv-super-app/palestras/voce-conhece-nossos-concorrentes.png"
              onClick={() => this.onCardClick("palestra", "6")}
            />
            <MiniCard
              inactive={true}
              type="palestra"
              date="Palestrante: Diego Feldberg"
              title="<b>Palestra:</b> Por que mudamos tanto?"
              localization="Auditório 3 - 16h30 às 18h00"
              thumb="https://pocs.digitalpages.com.br/bv-super-app/palestras/por-que-mudamos-tanto.png"
              onClick={() => this.onCardClick("palestra", "7")}
            /> */}
          </Slider>
        </div>

      </div>
    </div>);
  }
}
